const createCategoryMutation = `
  mutation CreateMarketplaceCategory($fields: CreateMarketplace_categoryFieldsInput) {
    createMarketplace_category(input: { fields: $fields }) {
      marketplace_category {
        objectId
        name
        icon {
          name
          url
        }
        cover {
          name
          url
        }
        createdAt
        updatedAt
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default createCategoryMutation;
